var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _line, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginIllustrationNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477,
    height: 388,
    viewBox: "0 0 477 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 240.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 240.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 240.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 240.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 269.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 269.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 269.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 269.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 298.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 298.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 298.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 298.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 327.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 327.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 327.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 327.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 356.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 356.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 356.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 356.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 385.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 385.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 385.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 385.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.5,
    cy: 3.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.5,
    cy: 3.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 3.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.5,
    cy: 3.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.5,
    cy: 32.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.5,
    cy: 32.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 32.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.5,
    cy: 32.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.5,
    cy: 61.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.5,
    cy: 61.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 61.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.5,
    cy: 61.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.5,
    cy: 90.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.5,
    cy: 90.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 90.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.5,
    cy: 90.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.5,
    cy: 119.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.5,
    cy: 119.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 119.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.5,
    cy: 119.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.5,
    cy: 148.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 420.5,
    cy: 148.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 148.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.5,
    cy: 148.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.95 366V236.81L208.241 42H79.0508V171.19L270.272 366H398.95Z",
    fill: "#EDEFF8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 237,
    width: 129.19,
    height: 129.19,
    fill: "#DDE1F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 42,
    width: 129.19,
    height: 129.19,
    fill: "#DDE1F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 72,
    width: 206,
    height: 108,
    fill: "#D7DEFF",
    fillOpacity: 0.53
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 262.5,
    y: 81.5,
    width: 205,
    height: 107,
    fill: "white",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 121,
    width: 40,
    height: 46,
    fill: "#E8EAF4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 103,
    width: 40,
    height: 64,
    fill: "#D3DAFA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 111,
    width: 40,
    height: 56,
    fill: "#E4E9FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 204,
    width: 206,
    height: 108,
    fill: "#D7DEFF",
    fillOpacity: 0.53
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 321,
    width: 21,
    height: 21,
    fill: "#E4E9FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 213.5,
    width: 205,
    height: 107,
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 255.5V231L126 230",
    stroke: "#799EFF",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 301,
    x2: 126,
    y2: 301,
    stroke: "#799EFF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M466.338 240C473.14 240 476.98 243.858 477 250.66V269.34C477 276.14 473.14 280 466.338 280H447.66C440.858 280 437 276.14 437 269.34V250.66C437 243.858 440.858 240 447.66 240H466.338ZM458 248.26C457.438 247.92 456.758 247.92 456.22 248.26C455.678 248.598 455.38 249.22 455.438 249.84V270.22C455.54 271.08 456.258 271.72 457.098 271.72C457.96 271.72 458.678 271.08 458.758 270.22V249.84C458.838 249.22 458.54 248.598 458 248.26ZM448.66 254.82C448.12 254.48 447.438 254.48 446.9 254.82C446.358 255.16 446.06 255.778 446.12 256.4V270.22C446.198 271.08 446.918 271.72 447.778 271.72C448.64 271.72 449.358 271.08 449.438 270.22V256.4C449.5 255.778 449.198 255.16 448.66 254.82ZM467.178 262.08C466.64 261.74 465.96 261.74 465.4 262.08C464.858 262.42 464.56 263.018 464.64 263.66V270.22C464.72 271.08 465.438 271.72 466.3 271.72C467.14 271.72 467.858 271.08 467.96 270.22V263.66C468.018 263.018 467.72 262.42 467.178 262.08Z",
    fill: "#E4E9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335 311.521C348.016 311.521 359 313.637 359 321.797C359 329.96 347.944 332 335 332C321.987 332 311 329.885 311 321.725C311 313.562 322.056 311.521 335 311.521Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M334.999 272C343.816 272 350.881 279.062 350.881 287.873C350.881 296.684 343.816 303.749 334.999 303.749C326.185 303.749 319.117 296.684 319.117 287.873C319.117 279.062 326.185 272 334.999 272Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.68 127C35.46 127 40 131.76 40 138.84V155.182C40 162.24 35.46 167 28.68 167H11.34C4.56 167 0 162.24 0 155.182V138.84C0 131.76 4.56 127 11.34 127H28.68ZM28.36 141C27.68 140.32 26.56 140.32 25.88 141L17.62 149.26L14.12 145.76C13.44 145.08 12.32 145.08 11.64 145.76C10.96 146.44 10.96 147.54 11.64 148.24L16.4 152.98C16.74 153.32 17.18 153.48 17.62 153.48C18.08 153.48 18.52 153.32 18.86 152.98L28.36 143.48C29.04 142.8 29.04 141.7 28.36 141Z",
    fill: "#E4E9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.031 352C184.929 352 189 355.969 189 362.764H180.538V362.833C176.61 362.833 173.427 365.937 173.427 369.766C173.427 373.595 176.61 376.699 180.538 376.699H189V377.323C189 384.031 184.929 388 178.031 388H159.969C153.071 388 149 384.031 149 377.323V362.677C149 355.969 153.071 352 159.969 352H178.031ZM187.507 365.745C188.331 365.745 189 366.397 189 367.201V372.262C188.99 373.062 188.327 373.709 187.507 373.718H180.698C178.71 373.744 176.971 372.417 176.52 370.529C176.294 369.357 176.611 368.147 177.386 367.224C178.161 366.302 179.315 365.76 180.538 365.745H187.507ZM181.498 368.085H180.84C180.436 368.08 180.047 368.233 179.76 368.51C179.473 368.787 179.311 369.164 179.311 369.558C179.311 370.384 179.993 371.056 180.84 371.066H181.498C182.342 371.066 183.027 370.399 183.027 369.575C183.027 368.752 182.342 368.085 181.498 368.085ZM169.764 359.782H158.476C157.638 359.782 156.956 360.439 156.947 361.256C156.947 362.082 157.628 362.754 158.476 362.764H169.764C170.609 362.764 171.293 362.096 171.293 361.273C171.293 360.45 170.609 359.782 169.764 359.782Z",
    fill: "#E4E9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.868 85.8787C136.339 85.6035 137.813 86.3376 138.454 87.6645C138.614 87.9053 138.742 88.1651 138.835 88.4375C139.242 94.728 139.677 100.912 140.084 107.096C140.075 107.739 140.176 108.378 140.383 108.988C140.871 110.188 142.084 110.95 143.399 110.881L163.367 109.601L163.503 109.655L163.868 109.681C164.59 109.773 165.263 110.103 165.774 110.621C166.37 111.226 166.696 112.039 166.682 112.88C165.895 124.346 157.488 133.927 146.048 136.395C134.608 138.863 122.881 133.626 117.263 123.542C115.612 120.637 114.568 117.438 114.193 114.133C114.048 113.153 113.984 112.164 114.003 111.174C114.041 98.9814 122.722 88.4574 134.868 85.8787Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.739 77.0025C160.452 77.413 171.912 87.3674 173.989 100.672C174.002 100.751 174.002 100.832 173.989 100.912L173.985 101.287C173.94 101.784 173.736 102.257 173.398 102.638C172.974 103.113 172.376 103.403 171.734 103.444L148.695 104.963L148.316 104.971C147.687 104.94 147.084 104.696 146.614 104.273C146.051 103.765 145.731 103.048 145.734 102.298L144.186 79.6679V79.2948C144.214 78.6583 144.499 78.059 144.978 77.629C145.457 77.199 146.091 76.9736 146.739 77.0025Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M287.9 3.5606C287.82 4.0606 287.78 4.5606 287.78 5.0606C287.78 9.5606 291.42 13.1986 295.9 13.1986C296.4 13.1986 296.88 13.1406 297.38 13.0606V29.1986C297.38 35.9806 293.38 40.0006 286.58 40.0006H271.802C265 40.0006 261 35.9806 261 29.1986V14.4006C261 7.6006 265 3.5606 271.802 3.5606H287.9ZM288.302 15.7206C287.76 15.6606 287.222 15.9006 286.9 16.3406L282.062 22.6006L276.52 18.2406C276.18 17.9806 275.78 17.8786 275.38 17.9206C274.982 17.9806 274.622 18.1986 274.38 18.5186L268.462 26.2206L268.34 26.4006C268 27.0386 268.16 27.8586 268.76 28.3006C269.04 28.4806 269.34 28.6006 269.68 28.6006C270.142 28.6206 270.58 28.3786 270.86 28.0006L275.88 21.5386L281.58 25.8206L281.76 25.9386C282.4 26.2786 283.2 26.1206 283.66 25.5186L289.44 18.0606L289.36 18.1006C289.68 17.6606 289.74 17.1006 289.52 16.6006C289.302 16.1006 288.82 15.7606 288.302 15.7206ZM296.18 0C298.84 0 301 2.16 301 4.82C301 7.48 298.84 9.64 296.18 9.64C293.52 9.64 291.36 7.48 291.36 4.82C291.36 2.16 293.52 0 296.18 0Z",
    fill: "#E4E9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustrationNew);
export default __webpack_public_path__ + "static/media/LoginIllustrationNew.0bee06ad625d40f07978e2bbee5f3442.svg";
export { ForwardRef as ReactComponent };